import React, { useMemo, useState } from "react";
import PopUpScreen from "../../component/popUpScreen/popUpScreen";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import accessManagementService from "../../services/accessManagementService";
import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "primereact/skeleton";
import { ChangeUserRoleMutation } from "../../mutations/AccessManagementMutationHook";
import { useToast } from "../../context/ToastContext";
import { GetLoggedInUserDetails } from "../../queries/appQueries";

function ChangeMemberRoleDialog({ onHide, userIds = [] }) {
  const toast = useToast();
  const [selectedAccess, setselectedAccess] = useState({});
  console.log(userIds);

  const { data: userDetails = [], isLoading: isUserDetailsLoading } = GetLoggedInUserDetails()

  const { data: allRoles = [], isLoading: isAllRolesDataLoading } = useQuery({
    queryKey: ["getAllUserRoles"],
    queryFn: () => accessManagementService.getAllRoles(),
  });

  const closeDialog = () => {
    onHide();
  };

  const { mutate: changeRoleApi, isPending: isChangingRole } =
    ChangeUserRoleMutation(
      () => {
        toast({
          severity: "info",
          summary: "Confirmed",
          detail: `Role Updated successfully`,
          life: 3000,
        });
       
        onHide();
      },
      (error) => {
        console.log(error);

        toast({
          severity: "info",
          summary: "Error",
          detail: error.response.data.detail,
          life: 3000,
        });
      }
    );

  const changeRole = () => {
    changeRoleApi(
      userIds.map((user) => {
        return {
          user_id: user.user_id,
          user_name: user.user_name,
          user_email: user.user_email,
          domain: user.domain,
          sub_domain: user.sub_domain,
          region: user.region,
          country: user.country,
          role_id: selectedAccess.role_id,
          is_active: true,
          end_date: null,
          last_modified_by: localStorage.getItem("userId"),
        };
      })
    );
  };

  const roleOptionTobeShown = useMemo(() => {
    if (userIds.length === 1) {
      console.log(userIds[0].role_name);

      return allRoles.filter(
        (role) =>
          role.priority_level >=
            Math.min(
              ...(userDetails?.data?.role_details.map(
                (item) => item.priority_level
              ) || [])
            ) && role.role_name !== userIds[0].role_name
      );
    }

    return allRoles.filter(
      (role) =>
        role.priority_level >=
        Math.min(
          ...(userDetails?.data?.role_details.map(
            (item) => item.priority_level
          ) || [])
        )
    );
  }, [allRoles, userDetails?.data?.role_details, userIds]);

  if (isUserDetailsLoading) {
    return (
      <PopUpScreen
        closable={false}
        header="Change Member Role"
        onHide={closeDialog}
        style={{ width: "30%" }}
      >
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <div className="flex gap-4 justify-content-end">
          <Skeleton height="3rem" width="5rem" className="my-1"></Skeleton>
          <Skeleton height="3rem" width="5rem" className="my-1"></Skeleton>
        </div>
      </PopUpScreen>
    );
  }

  return (
    <PopUpScreen
      closable={false}
      header="Change Member Role"
      onHide={closeDialog}
      style={{ width: "30%" }}
    >
      <div className="grid">
        <div className="col-12">
          <Dropdown
            loading={isAllRolesDataLoading}
            style={{ width: "100%", marginBottom: "5px" }}
            value={selectedAccess}
            onChange={(e) => setselectedAccess(e.value)}
            options={roleOptionTobeShown}
            optionLabel="role_name"
            placeholder="Select the Access"
            className="w-full "
          />

          {/* <ErrorMessage  message={"dsfs"} /> */}
        </div>
      </div>
      <div className="grid">
        <div className="col-12" style={{ textAlign: "right" }}>
          <Button
            disabled={isChangingRole}
            label="Cancel"
            style={{ marginRight: "10px" }}
            onClick={() => closeDialog()}
            outlined
          />
          <Button
            disabled={isChangingRole || !Object.keys(selectedAccess).length > 0}
            loading={isChangingRole}
            label="Save"
            onClick={changeRole}
          />
        </div>
      </div>
    </PopUpScreen>
  );
}

export default ChangeMemberRoleDialog;
